import { Directive, EventEmitter, Output } from '@angular/core';
// import { MediaPlayerService } from 'src/app/modules/loyalty/components/media/media-player/media-player.service';

/*
 * An abstract directive to be implemented by all playable media components (e.g., YouTube, Vimeo, Twitch).
 * It registers media control playback methods.
 * Extend this class when adding new playable media components.
 */
@Directive()
export abstract class Playable {
  @Output() onReady = new EventEmitter<void>();
  public abstract play(): void;
  public abstract pause(): void; // not implemented yet, but reserved for future use
  public abstract stop(): void; // not implemented yet, but reserved for future use
}
